// extracted by mini-css-extract-plugin
module.exports = {"firstPage":"oneProfileForm_firstPage__3FgkO","nextButton":"oneProfileForm_nextButton__21QB6","nextButtonDisabled":"oneProfileForm_nextButtonDisabled__1Im6I"};